import moment from 'moment';

export const getAppointmentTimeLabel = (time) => {
  if (!time) return '';
  return time.includes(' - ') ? time.split(' - ')[0].trim() : time.trim();
};

export const buildAppointmentMoment = (reminderDate, time) => {
  if (!reminderDate) return null;
  const timeLabel = getAppointmentTimeLabel(time);
  if (timeLabel) {
    const dateOnly = moment(reminderDate).format('YYYY-MM-DD');
    const parsed = moment(`${dateOnly} ${timeLabel}`, 'YYYY-MM-DD hh:mm A', true);
    if (parsed.isValid()) {
      return parsed;
    }
  }
  return moment(reminderDate);
};

export const buildAppointmentStart = (reminderDate, time) => {
  const appointmentMoment = buildAppointmentMoment(reminderDate, time);
  return appointmentMoment ? appointmentMoment.toDate() : null;
};

export const formatAppointmentReminderBadge = (reminderNoteData) => {
  const appointmentMoment = buildAppointmentMoment(
    reminderNoteData?.reminderDate,
    reminderNoteData?.time
  );
  if (!appointmentMoment) return null;

  return {
    dateLabel: appointmentMoment.format('MMM DD, YYYY'),
    timeLabel: appointmentMoment.format('hh:mm A'),
    fullLabel: appointmentMoment.format('MMMM DD, YYYY hh:mm:ss A'),
    moment: appointmentMoment,
  };
};

export const formatAppointmentDateTime = (appointment) => {
  const appointmentMoment = buildAppointmentMoment(
    appointment.date || appointment.start,
    appointment.time
  );
  if (!appointmentMoment) return '';

  const timeLabel = getAppointmentTimeLabel(appointment.time);
  if (timeLabel) {
    return `${appointmentMoment.format('D MMMM')} ${timeLabel}`;
  }
  return appointmentMoment.format('D MMMM h:mm A');
};

export const isAppointmentOverdue = (reminderNoteData) => {
  const appointmentMoment = buildAppointmentMoment(
    reminderNoteData?.reminderDate,
    reminderNoteData?.time
  );
  return appointmentMoment ? appointmentMoment.isBefore(moment()) : false;
};

// Matches the .delete-note-click button color theme (background: #f44336 !important) so Cancelled
// reads as visually consistent with the app's existing "destructive" red.
const REMINDER_STATUS_BADGES = {
  Cancelled: { label: 'Cancelled', background: '#f44336', border: '#f44336', color: '#fff', icon: 'mdi-close-circle-outline' },
};

// Only the Cancelled state gets a badge here - Pending ('Reminder'/'Sent') and Completed are left
// unbadged so the row stays clean and the Cancelled ones stand out.
export const getReminderStatusBadge = (reminderNoteData) => {
  const status = reminderNoteData?.status;
  if (status === 'Cancelled') return REMINDER_STATUS_BADGES.Cancelled;
  return null;
};
